import { useSelector, useDispatch } from "react-redux";
import { Box, HStack, Button } from "@chakra-ui/react";

import BranchSelection from "./BranchSelection";
import DatePicker from "./DatePicker";
import Select from "../averly/Select";
import { getExportCount, setExportTimeUnit } from "../../store/actions/exportActions";

const TIME_UNIT_OPTIONS = [
  { id: "seconds", name: "Seconds" },
  { id: "minutes", name: "Minutes" },
];

function ExportDataFilterForm() {
  const dispatch = useDispatch();
  const { dateRange, organizationId, branchId } = useSelector(
    (store) => store.defaultReducer
  );
  const { isFetchingExport, timeUnit } = useSelector((store) => store.exportReducer);

  if (!organizationId.length) {
    return null;
  }

  const handleSearch = () => {
    dispatch(
      getExportCount({
        organizationId,
        branchId,
        createdFrom: dateRange[0],
        createdTo: dateRange[1],
      })
    );
  };

  const handleTimeUnitChange = (value) => {
    dispatch(setExportTimeUnit(value));
  };

  return (
    <Box
      overflow="visible"
      borderBottom="1px solid #ebebeb"
      m="0 -15px 30px"
      p="0 15px 15px"
    >
      <HStack overflow="visible" gap="15px">
        <Box>
          <BranchSelection />
        </Box>
        <Box>
          <DatePicker calendarType="month" />
        </Box>
        <Box w="150px">
          <Select
            label="Duration Unit"
            value={timeUnit}
            options={TIME_UNIT_OPTIONS}
            onChange={handleTimeUnitChange}
          />
        </Box>
        <Box>
          <Button
            w="200px"
            h="56px"
            borderRadius="8px"
            background="#222"
            color="var(--white)"
            _hover={{ bg: "#000" }}
            onClick={handleSearch}
            disabled={isFetchingExport}
            loading={isFetchingExport}
            loadingText="Searching..."
          >
            Search
          </Button>
        </Box>
      </HStack>
    </Box>
  );
}

export default ExportDataFilterForm;
